import { RequestContext } from "../request-context";
import {
    NavigationLogo,
    NavigationMainMenu,
    NavigationSearchForm,
    NavigationYourAccount,
    NavigationLocaleSelector,
    NavigationSignUpCTA,
    NavigationNewItemNotification
} from "./navigation";

import { SearchResult, Summary, Refinement, Paginator } from "./search";

export interface wpsEntity {
    __type?: string,
    '*className*'?: string
}

export enum SharedWPSTypes {
    PaginatorPageNo = 'atv.wps#PaginatorPageNo',
    PaginatorNext = 'atv.wps#PaginatorNext',
    PaginatorPrevious = 'atv.wps#PaginatorPrevious',
    PaginatorGap = 'atv.wps#PaginatorGap'
}

export interface Link {
    href: string;
    text: string;
}

export interface Pagination {
    endpoint: DestructuredURL;
    paginator: PaginatorItem[];
}

export interface StringMap {
    [key: string]: string;
}

export interface DestructuredURL {
    partialURL: string;
    query: {
        [key: string]: string;
    };
}

export interface WatchlistAction {
    text: string|DVString;
    tag: string;
    endpoint: DestructuredURL;
    ajaxEnabled: boolean;
}

export type PaginatorItem = PaginatorElementType | PaginatorGap

export interface PaginatorGap {
    __type: 'atv.wps#PaginatorGap'
}

export type PaginatorElementType = PaginatorPageNo | PaginatorPrevious | PaginatorNext

export interface PaginatorElement {
    href: string;
    title: string;
}

export interface PaginatorPageNo extends PaginatorElement {
    text: string;
    isOptional: boolean;
    __type: SharedWPSTypes.PaginatorPageNo;
}

export interface PaginatorPrevious extends PaginatorElement {
    __type: SharedWPSTypes.PaginatorPrevious
}

export interface PaginatorNext extends PaginatorElement {
    __type: SharedWPSTypes.PaginatorNext
}

export interface DVString {
    string: string;
    attrs: {
        [key: string]: {
            [key: string]: string;
        };
    };
}

export enum TitleType {
    Movie = 'movie',
    Episode = 'episode',
    Season = 'season',
    Show = 'show'
}

export enum VideoMaterialType {
    FEATURE = 'Feature',
    TRAILER = 'Trailer',
    LIVE = 'Live',
    UNKNOWN = 'Unknown'
}


export interface TrailerFragment {
    playbackID: string,
    playbackURL: string,
    text?: string,
    videoMaterialType: VideoMaterialType
}

export namespace WPS.Footer {
    export interface Request {
        context: RequestContext;
    }
    export interface Response {
        copyright: string;
        links: Link[];
        debug?: object;
    }
}

export namespace WPS.Navigation {
    export interface Request {
        context: RequestContext;
        pageGating?: string;
        searchPhrase?: string;
        isCrow?: boolean;
        isWaymark?: boolean;
        isElcano?: boolean;
    }
    export interface Response {
        isSticky?: boolean;
        logo: NavigationLogo;
        mainMenu?: NavigationMainMenu;
        signUpCTA?: NavigationSignUpCTA;
        searchForm?: NavigationSearchForm;
        yourAccount: NavigationYourAccount;
        localeSelector?: NavigationLocaleSelector;
        newItemNotification?: NavigationNewItemNotification;
        debug?: object;
    }
}

export namespace WPS.Search {
    export interface Request {
        context: RequestContext;
        phrase: string;
        startIndex?: number;
        pageIndex?: number;
        maxItems?: number;
        queryToken?: string;
        pageId?: string;
        queryPageType?: string;
        isCrow?: boolean;
    }
    export interface Response {
        title?: DVString;
        items: SearchResult[];
        summary?: Summary[];
        refinement?: Refinement;
        pagination?: {
            endpoint?: string;
            paginator: Paginator[];
        };
        infiniteScrollRefMarker: string;
        totalItems: number;
        infiniteScrollEnabled?: boolean;
        isHighContrastCards?: boolean;
        isHover2019?: boolean;
        useNewMaturityBadges: boolean;
        debug?: object;
    }
}

export namespace WPS.SearchSuggestions {
    export interface Request {
        context: RequestContext;
        phrase: string;
        maxSuggestions: number;
    }
    export interface Response {
        __type: 'atv.wps#SearchSuggestionsOnly' | 'atv.wps.SearchSuggestionsOnly';
        suggestions: Link[];
    }
}